/* eslint-disable @typescript-eslint/no-unused-vars */
import { Component, ReactNode } from 'react';
import * as Sentry from '@sentry/react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

const FallbackComponent = () => (
  <div>
    <h1>An error has occurred</h1>
  </div>
);

class ErrorBoundary extends Component<Props, State> {

  constructor(props: Props) {
    super(props);
    this.state = {
      hasError: false,
    };
  }

  static getDerivedStateFromError(_: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  render(): ReactNode {
    const { hasError } = this.state;
    const { children } = this.props;

    return (
      <Sentry.ErrorBoundary fallback={FallbackComponent} showDialog>
        {children}
      </Sentry.ErrorBoundary>
    );
  }
}

export default ErrorBoundary;
